import axios from 'axios'

const {
  REACT_APP_API_BASE_URL
} = process.env

export async function getHealth() {
  const url = `${REACT_APP_API_BASE_URL}/health`
  return axios.get<{ maintenanceMode: boolean }>(url, {
    timeout: 30000,
    validateStatus: statusCode => statusCode === 200,
  }).then(response => response.data);
}
